import protocolCheck from '~/modules/protocol-check.js';
var ClockElement = document.getElementById('clock');

function ClockCall() {
    if (ClockElement) ClockElement.textContent = moment().format('LT');
}

ClockCall();

setInterval(ClockCall, 1000);
angular
    .module('tradersyard')
    .directive('ranktext', [
        function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    scope.$watch(
                        function () {
                            return element.text().trim();
                        },
                        function (o, n) {
                            // console.log(o, n);
                            // if (o !== n) {
                            // var len =  element.find('span').text().trim().length;
                            // if (len === 5) {
                            //   element.find('span').css({'font-size': '18px'});
                            // } else if (len >= 6) {
                            //   element.find('span').css({'font-size': '14px'});
                            // } else {
                            //   element.find('span').css({'font-size': '24px'});
                            // }
                            // }
                        }
                    );
                },
            };
        },
    ])
    .directive('treeModel', [
        '$compile',
        '$parse',
        function ($compile, $parse) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var treeId = attrs.treeId;

                    var treeModel = attrs.treeModel;

                    var nodeId = attrs.nodeId || 'id';

                    var nodeLabel = attrs.nodeLabel || 'label';

                    var nodeChildren = attrs.nodeChildren || 'children';

                    var template =
                        '<ul>' +
                        '<li ng-repeat="node in ' +
                        treeModel +
                        '">' +
                        '<i class="collapsed icon-yard-top-right" ng-show="node.' +
                        nodeChildren +
                        '.length && node.collapsed" ng-click="' +
                        treeId +
                        '.selectNodeHead(node)"></i>' +
                        '<i class="expanded icon-yard-top" ng-show="node.' +
                        nodeChildren +
                        '.length && !node.collapsed" ng-click="' +
                        treeId +
                        '.selectNodeHead(node)"></i>' +
                        '<i class="normal" ng-hide="node.' +
                        nodeChildren +
                        '.length"></i> ' +
                        '<span class="normal" ng-class="{\'selected icon-yard-check\':node.selected}" ng-click="' +
                        treeId +
                        '.selectNodeLabel(node)">{{node.' +
                        nodeLabel +
                        '}}</span>' +
                        '<div ng-hide="node.collapsed" tree-id="' +
                        treeId +
                        '" tree-model="node.' +
                        nodeChildren +
                        '" node-id=' +
                        nodeId +
                        ' node-label=' +
                        nodeLabel +
                        ' node-children=' +
                        nodeChildren +
                        '></div>' +
                        '</li>' +
                        '</ul>';

                    var walk = function ($array, $call) {
                        for (var i = 0; i < $array.length; i++) {
                            $call($array[i]);

                            if ($array[i][nodeChildren].length > 0) walk($array[i][nodeChildren], $call);
                        }
                    };

                    if (treeId && treeModel) {
                        if (attrs.angularTreeview) {
                            scope[treeId] = scope[treeId] || {};

                            scope[treeId].selectNodeHead =
                                scope[treeId].selectNodeHead ||
                                function (selectedNode) {
                                    selectedNode.collapsed = !selectedNode.collapsed;
                                };

                            scope[treeId].selectNodeLabel =
                                scope[treeId].selectNodeLabel ||
                                function (selectedNode) {
                                    if (scope[treeId].currentNode && scope[treeId].currentNode.selected) {
                                        scope[treeId].currentNode.selected = false;
                                    }

                                    selectedNode.selected = true;

                                    scope[treeId].currentNode = selectedNode;

                                    if (attrs.pool) {
                                        $parse(attrs.pool).assign(scope, selectedNode);
                                    }
                                };

                            walk($parse(treeModel)(scope), function (item) {
                                if (parseInt(item[nodeId]) === parseInt($parse(attrs.pool)(scope)[nodeId])) {
                                    item.selected = true;

                                    scope[treeId].currentNode = item;
                                }
                            });
                        }

                        element.html('').append($compile(template)(scope));
                    }
                },
            };
        },
    ])
    .directive('scrollTop', [
        '$window',
        function ($window) {
            return {
                priority: 50,
                link: function (scope, element, attr) {
                    scope.y = 0;
                    scope.button = angular.element(element[0].querySelector('[scroll-button]'));
                    scope.scroll = angular.element(element[0]);

                    scope.scroll.css({
                        display: 'none',
                    });

                    angular.element(window).bind('scroll', function () {
                        if (2 * window.innerHeight < window.pageYOffset) {
                            scope.scroll.css({
                                display: 'block',
                            });
                            scope.y = $window.scrollY;

                            scope.scroll.bind('click', function () {
                                window.scrollTo(0, 0);
                            });
                        } else {
                            scope.scroll.css({
                                display: 'none',
                            });
                        }
                    });
                },
            };
        },
    ])
    .directive('openChatHandler', [
        '$rootScope',
        function ($rootScope) {
            return {
                link: function (scope, element, attr) {
                    var isChatOpen = false;

                    $rootScope.$on('onClickOpenChat', function () {
                        if (isChatOpen) {
                            element.css({
                                display: 'none',
                            });
                        } else {
                            element.css({
                                display: 'block',
                            });
                        }
                        isChatOpen = !isChatOpen;
                    });
                },
            };
        },
    ])
    .directive('openChat', [
        '$rootScope',
        function ($rootScope) {
            return {
                link: function (scope, element, attr) {
                    element.bind('click', function () {
                        $rootScope.$broadcast('onClickOpenChat', true);
                    });
                },
            };
        },
    ])
    .directive('mobileChat', [
        '$rootScope',
        '$parse',
        function ($rootScope, $parse) {
            return {
                link: function (scope, element, attr) {
                    element.bind('click', function () {
                        // When this is set to true, the body scrolling will be disabled.
                        // This is to avoid scrolling away from the content you were viewing when scrolling in chat.
                        var mobileChatHandle = $parse(attr.mobileChatHandle)(scope);
                        var body = angular.element(document).find('body');

                        if (mobileChatHandle) {
                            body.addClass('disable-scroll has-mobile-chat-open');
                        } else {
                            body.removeClass('disable-scroll has-mobile-chat-open');
                        }
                        scope.$apply();
                    });
                },
            };
        },
    ])
    .directive('dropdownPosition', [
        '$timeout',
        '$rootScope',
        '$parse',
        /**
         * Directive for change the position of the drop-down menu relative to the position in the block.
         *
         * accepts 3 parameters
         * dropdown-position-body  - is a scrollable block
         * dropdown-position-list  - is a list that will open either up or down
         * dropdown-position-entry - is a block that contains a button and a popup list that slides into the body of another block
         *
         * Example: (package/graph-head/view/graph/message/node.php)
         * dropdown-position
         * dropdown-position-body="'#message-container'"
         * dropdown-position-list="'.dropdown'"
         * dropdown-position-entry="'#item-{{message.id}}'"
         *
         * @param $timeout
         * @param $rootScope
         * @param $parse
         * @returns {{link: dropdownPosition.link, restrict: string}}
         */
        function ($timeout, $rootScope, $parse) {
            return {
                restrict: 'A',
                link: function ($scope, $element, $attr, $rootScope) {
                    $timeout(function () {
                        var dropdownPositionBody = $parse($attr.dropdownPositionBody)($scope) || 'body',
                            dropdownPositionList = $parse($attr.dropdownPositionList)($scope),
                            dropdownPositionEntry = $parse($attr.dropdownPositionEntry)($scope);

                        $element.bind('click', function () {
                            var entry = $(dropdownPositionEntry);
                            var bodyListHeight = $(dropdownPositionBody).outerHeight();
                            var topOffset = entry.offset().top;
                            var dropdownList = entry.children(dropdownPositionList);
                            var dropdownListHeight = dropdownList.height();
                            var dropdownOffset = $(dropdownPositionBody).offset().top;

                            if (topOffset + dropdownListHeight + 33 > dropdownOffset + bodyListHeight) {
                                dropdownList.addClass('reverse');
                            } else {
                                dropdownList.removeClass('reverse');
                            }
                        });
                    });
                },
            };
        },
    ])
    .directive('fileHelper', [
        '$timeout',
        '$parse',
        'graph-photo-factory',
        'graph-video-factory',
        'graph-document-factory',
        function ($timeout, $parse, $photo, $video, $document) {
            return {
                scope: true,
                link: function ($scope, $element, $attr) {
                    var entry, entryId;

                    var clients = {
                        photo: $photo,
                        video: $video,
                        document: $document,
                    };

                    $scope.fileType = undefined;

                    $scope.client = {
                        photo: undefined,
                        video: undefined,
                        document: undefined,
                    };

                    $scope.handle = {
                        update: function () {
                            if ($attr.afterUpdate) {
                                var phase = $scope.$parent.$$phase;
                                if (phase == '$apply' || phase == '$digest') $scope.$parent.$eval($attr.afterUpdate);
                                else $scope.$parent.$apply($attr.afterUpdate);
                            }
                        },
                        delete: function () {
                            if ($attr.afterDelete) {
                                var phase = $scope.$parent.$$phase;
                                if (phase == '$apply' || phase == '$digest') $scope.$parent.$eval($attr.afterDelete);
                                else $scope.$parent.$apply($attr.afterDelete);
                            }
                        },
                    };

                    $timeout(function () {
                        entry = $parse($attr.entry)($scope) || undefined;
                        entryId = $parse($attr.entryId)($scope) || 0;
                        $scope.fileType = $parse($attr.fileType)($scope) || undefined;

                        $scope.client[$scope.fileType] = clients[$scope.fileType].entry(entry, entryId);
                    });
                },
                controller: [
                    '$scope',
                    function ($scope) {
                        $scope.filter = function (value) {
                            return value && value.length > 0 && value.length <= 255;
                        };

                        $scope.update = function (node) {
                            $timeout(function () {
                                $scope.client[$scope.fileType]
                                    .update(node.id, { name: node.name })
                                    .then(function (response) {
                                        if (response.data.state === 0) {
                                            $scope.handle.update();
                                        }
                                    });
                            }, 10);
                        };

                        $scope.delete = function (node, index) {
                            $scope.client[$scope.fileType].delete(node.id).then(function (response) {
                                if (response.data.state === 0) {
                                    if ($scope.fileType == 'document') {
                                        $scope.documents.splice(index, 1);
                                    }

                                    $scope.handle.delete();
                                }
                            });
                        };
                    },
                ],
            };
        },
    ])
    .directive('elastic', [
        '$timeout',
        function ($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, element) {
                    $scope.$watch(
                        function () {
                            return element[0].value;
                        },
                        function (o, n) {
                            if (o !== n) resize();
                        }
                    );
                    $scope.initialHeight = $scope.initialHeight || element[0].style.height;
                    var resize = function () {
                        element[0].style.height = $scope.initialHeight;
                        element[0].style.height = '' + element[0].scrollHeight + 'px';
                    };
                    $timeout(resize, 0);
                },
            };
        },
    ])
    .directive('preview', [
        '$timeout',
        '$rootScope',
        '$parse',
        function ($timeout, $root, $parse) {
            return {
                restrict: 'A',
                link: function ($scope, $element, $attr) {
                    $timeout(function () {
                        var $data,
                            previewType = $parse($attr.previewType)($scope) || 'image',
                            previewElement = $parse($attr.previewElement)($scope) || 'img',
                            previewAccess = $parse($attr.previewAccess)($scope) || false,
                            previewEntry = $parse($attr.previewEntry)($scope) || undefined,
                            previewEntryId = $parse($attr.previewEntryId)($scope) || undefined;

                        $scope.$watch(
                            function () {
                                $data = $parse($attr.preview)($scope);
                                return $data?.length ?? 0;
                            },
                            function () {
                                var nodes = angular.element(
                                    $element[0].querySelectorAll(
                                        previewType === 'video' ? previewElement : previewElement
                                    )
                                );

                                var handlers = angular.element(
                                    $element[0].querySelectorAll(
                                        previewType === 'video' ? previewElement + ' *' : previewElement
                                    )
                                );

                                angular.forEach(nodes, function (node, k) {
                                    angular.element(node).attr('preview-id', k);
                                });

                                var call = function (e) {
                                    e.preventDefault();

                                    function find_parent_video(element) {
                                        if (element) {
                                            if (element.tagName === 'VJS-VIDEO-CONTAINER') {
                                                return element;
                                            } else {
                                                return find_parent_video(element.parentNode);
                                            }
                                        } else {
                                            return null;
                                        }
                                    }

                                    if ($root.me) {
                                        e.stopPropagation();

                                        // IMPORTANT: This event is used for tracking Social Advertising engagements
                                        $root.$broadcast('preview-touch', {
                                            nodes:
                                                typeof $data === 'function'
                                                    ? $data()
                                                    : angular.isArray($data) === false
                                                    ? [$data]
                                                    : $data,
                                            current: parseInt(
                                                angular
                                                    .element(
                                                        previewType === 'video' ? find_parent_video(e.target) : e.target
                                                    )
                                                    .attr('preview-id')
                                            ),
                                            type: previewType,
                                            access: previewAccess,
                                            entry: previewEntry,
                                            entryId: previewEntryId,
                                            pool: $parse($attr.preview)($scope),
                                            // IMPORTANT Store target element. We need this to track the source of the event for Social Ads.
                                            //  We will check if the click source is contained inside promoted post wrapper.
                                            target: e.target,
                                        });
                                    }
                                };

                                handlers.unbind('click', call).bind('click', call);
                                // handlers.unbind('touchstart', call).bind('touchstart', call);
                            }
                        );
                    });
                },
            };
        },
    ])
    .directive('momentWatch', [
        '$filter',
        '$parse',
        function ($filter, $parse) {
            return {
                priority: 50,
                link: function (scope, element, attr, model) {
                    var intervalId;
                    var timeModel = $parse(attr.momentWatch)(scope);

                    function startMomentWatch() {
                        if (intervalId) {
                            clearInterval(intervalId);
                            intervalId = undefined;
                        }

                        element.text($filter('moment')(timeModel, 'smart'));
                        intervalId = setInterval(function () {
                            element.text($filter('moment')(timeModel, 'smart'));
                        }, 30 * 1000);
                    }

                    startMomentWatch();
                },
            };
        },
    ])
    .directive('flexDirection', [
        function () {
            return {
                priority: 50,
                link: function (scope, element, attr, model) {
                    function checkRTL(s) {
                        var ltrChars =
                                'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF' +
                                '\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF',
                            rtlChars = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC',
                            rtlDirCheck = new RegExp('^[^' + ltrChars + ']*[' + rtlChars + ']');

                        return rtlDirCheck.test(s);
                    }

                    scope.$watch(
                        function () {
                            return element.text();
                        },
                        function () {
                            element.css('direction', checkRTL(element.text()) ? 'rtl' : 'ltr');
                        }
                    );
                },
            };
        },
    ])
    .directive('elasticPageForm', [
        function () {
            return {
                priority: 50,
                link: function (scope, element, attr, model) {
                    scope.$watch(function () {
                        setTimeout(function () {
                            var height = element[0].clientHeight;
                            angular
                                .element(document.querySelector(attr.elasticPageForm))
                                .css('bottom', String(height) + 'px');
                        }, 0);
                    });
                },
            };
        },
    ])
    .directive('fixedElementsOverflowController', [
        '$window',
        '$document',
        function ($window, $document) {
            return {
                priority: 50,
                link: function (scope, element, attr, model) {
                    function resize() {
                        var relativeElement = document.querySelector(attr.fixedElementsRelativeElement),
                            offset = relativeElement
                                ? window.innerHeight - relativeElement.getBoundingClientRect().top
                                : 0;

                        if (offset < 0) {
                            offset = 0;
                        }

                        element.css('margin-bottom', String(offset) + 'px');
                    }

                    resize();

                    angular.element($window).bind('resize scroll', function () {
                        resize($window);
                    });
                },
            };
        },
    ])
    .directive('elasticPaddingBotom', [
        '$window',
        function ($window) {
            return {
                priority: 50,
                link: function (scope, element, attr, model) {
                    function resize(window) {
                        var offset = 0;

                        attr.elasticPaddingBotomOffset.split(':').forEach(function (selector) {
                            var el = document.querySelector(selector);

                            if (el !== null) {
                                offset += el.clientHeight;
                            }
                        });

                        offset += Number(attr.elasticPaddingBotomPadding);

                        element.css('padding-bottom', String(offset) + 'px');
                    }

                    resize($window);

                    angular.element($window).bind('resize', function () {
                        resize($window);
                    });
                },
            };
        },
    ])
    .directive('elasticWidget', [
        '$window',
        function ($window) {
            return {
                priority: 50,
                link: function (scope, element, attr, model) {
                    function resize(window) {
                        var offset = 0,
                            wHeight = window.innerHeight;

                        attr.elasticWidgetOffset.split(':').forEach(function (selector) {
                            var el = document.querySelector(selector);

                            if (el !== null) {
                                offset += el.clientHeight;
                            }
                        });

                        offset += Number(attr.elasticWidgetPadding);

                        var height = wHeight - offset <= 0 ? 0 : wHeight - offset;

                        element.css('height', String(height) + 'px');
                    }

                    resize($window);

                    angular.element($window).bind('resize', function () {
                        resize($window);
                    });
                },
            };
        },
    ])
    .directive('elasticIntervalWidget', [
        '$window',
        '$timeout',
        '$rootScope',
        function ($window, $timeout, $root) {
            return {
                priority: 50,
                link: function (scope, element, attr, model) {
                    function resize() {
                        var startEl = document.querySelector(attr.elasticIntervalStart),
                            endEl = document.querySelector(attr.elasticIntervalEnd),
                            altEndEl = document.querySelector(attr.elasticIntervalAlternativeEnd);

                        var top = Number(startEl.offsetTop) + Number(startEl.clientHeight),
                            bot =
                                endEl === null || endEl.classList.contains('ng-hide')
                                    ? Number(altEndEl.offsetTop) +
                                      Number(altEndEl.clientHeight) -
                                      Number(attr.elasticIntervalAlternativePadding)
                                    : endEl.offsetTop;

                        var height = bot - top;

                        element.css('max-height', String(height) + 'px');

                        $root.$broadcast('messageBlockResized', {});
                    }

                    resize();

                    scope.$watch(
                        function () {
                            return element.html();
                        },
                        function (newValue, oldValue) {
                            if (newValue !== oldValue) {
                                // console.log('resize');
                                resize();
                            }
                        }
                    );

                    angular.element($window).bind('resize', function () {
                        $timeout(function () {
                            resize();
                        }, 0);
                    });

                    attr.elasticIntervalHandlers.split(':').forEach(function (handler) {
                        var el = document.querySelector(handler);

                        scope.$watch(
                            function () {
                                return el.clientHeight;
                            },
                            function () {
                                $timeout(function () {
                                    resize();
                                }, 0);
                            }
                        );
                    });

                    attr.elasticIntervalEvents.split(':').forEach(function (event) {
                        $root.$on(event, function () {
                            $timeout(function () {
                                resize();
                            }, 0);
                        });
                    });
                },
            };
        },
    ])
    .directive('resizer', [
        '$document',
        '$timeout',
        '$rootScope',
        function ($document, $timeout, $root) {
            return {
                priority: 10,
                link: function ($scope, $element, $attrs) {
                    $root.$on('messageBlockResized', function () {
                        $timeout(function () {
                            $element.on('mousedown', function (event) {
                                event.preventDefault();

                                $document.on('mousemove', mousemove);
                                $document.on('mouseup', mouseup);
                            });
                        });
                    });

                    function mousemove(event) {
                        const y = window.innerHeight - event.pageY;
                        $scope.position = y;
                        let newPosition = y - 55 + 'px';
                        let containerHeight = $($attrs.resizerContainer).height();
                        let minH = (containerHeight / 100) * 25 + 150;
                        let maxH = (containerHeight / 100) * 75 + 150;

                        if (y > minH && y < maxH) {
                            $element.css({
                                bottom: newPosition,
                            });

                            $($attrs.resizerTop).css({
                                bottom: newPosition,
                            });
                            $($attrs.resizerBottom).css({
                                height: newPosition,
                            });
                        }
                    }

                    function mouseup() {
                        $document.unbind('mousemove', mousemove);
                        $document.unbind('mouseup', mouseup);

                        $root.$broadcast('splitebar.resized', {});
                    }
                },
            };
        },
    ])
    .directive('flexScreen', [
        '$rootScope',
        '$window',
        function ($root, $window) {
            return {
                priority: 50,
                link: function (scope, element, attr, model) {
                    $root.break = null;

                    function resize(size, name, init) {
                        if (size >= 1800) {
                            name = 'huge';
                        } else if (size >= 1200 && size < 1799) {
                            name = 'large';
                        } else if (size >= 980 && size < 1199) {
                            name = 'default';
                        } else if (size >= 768 && size < 979) {
                            name = 'small';
                        } else if (size >= 320 && size < 767) {
                            name = 'tablet';
                        } else if (size < 319) {
                            name = 'phone';
                        }

                        if ($root.break !== name) {
                            $root.break = name;

                            if (!$root.$$phase) $root.$digest();

                            $root.$broadcast('screen:break', name);
                        }
                    }

                    angular.element($window).bind('resize', function () {
                        resize($window.outerWidth);
                    });

                    resize($window.outerWidth, 'large', true);
                },
            };
        },
    ])
    .directive('readMoreLink', function () {
        return {
            restrict: 'A',
            transclude: true,
            replace: true,
            template: '<p></p>',
            scope: {
                moreText: '@',
                lessText: '@',
                words: '@',
                ellipsis: '@',
                char: '@',
                limit: '@',
                content: '@',
            },
            link: function (scope, elem, attr, ctrl, transclude) {
                var moreText = angular.isUndefined(scope.moreText)
                        ? ' <a class="read-more">Read More...</a>'
                        : ' <a class="read-more">' + scope.moreText + '</a>',
                    lessText = angular.isUndefined(scope.lessText)
                        ? ' <a class="read-less">Less ^</a>'
                        : ' <a class="read-less">' + scope.lessText + '</a>',
                    ellipsis = angular.isUndefined(scope.ellipsis) ? '' : scope.ellipsis,
                    limit = angular.isUndefined(scope.limit) ? 150 : scope.limit;

                attr.$observe('content', function (str) {
                    readmore(str);
                });

                transclude(scope.$parent, function (clone, scope) {
                    readmore(clone.text().trim());
                });

                function readmore(text) {
                    var orig = text,
                        regex = /\s+/gi,
                        charCount = text.length,
                        wordCount = text.trim().replace(regex, ' ').split(' ').length,
                        countBy = 'char',
                        count = charCount,
                        foundWords = [],
                        markup = text,
                        more = '';

                    if (!angular.isUndefined(attr.words)) {
                        countBy = 'words';
                        count = wordCount;
                    }

                    if (countBy === 'words') {
                        // Count words

                        foundWords = text.split(/\s+/);

                        if (foundWords.length > limit) {
                            text = foundWords.slice(0, limit).join(' ') + ellipsis;
                            more = foundWords.slice(limit, count).join(' ');
                            markup = text + moreText + '<span class="more-text">' + more + lessText + '</span>';
                        }
                    } else {
                        // Count characters

                        if (count > limit) {
                            text = orig.slice(0, limit) + ellipsis;
                            more = orig.slice(limit, count);
                            markup = text + moreText + '<span class="more-text">' + more + lessText + '</span>';
                        }
                    }

                    elem.append(markup);
                    elem.find('.read-more').on('click', function () {
                        $(this).hide();
                        elem.find('.more-text').addClass('show').slideDown();
                    });
                    elem.find('.read-less').on('click', function () {
                        elem.find('.read-more').show();
                        elem.find('.more-text').hide().removeClass('show');
                    });
                }
            },
        };
    })
    .directive('readMore', [
        '$window',
        '$timeout',
        function ($window, $timeout) {
            return {
                restrict: 'AE',
                controller: [
                    '$scope',
                    '$attrs',
                    '$element',
                    function ($scope, $attrs, $element) {
                        $scope.maxHeight = $attrs.readMoreHeight ? $attrs.readMoreHeight : 300;
                        $scope.content = angular.element($element[0].querySelector('[read-more-content]'));
                        $scope.expand = angular.element($element[0].querySelector('[read-more-expand]'));
                        $scope.button = angular.element($element[0].querySelectorAll('[read-more-button]'));
                        $scope.overflow = false;
                        $scope.yPost = 0;
                        $scope.isExpanded = false;

                        function expand() {
                            if ($scope.isExpanded === false) $scope.yPos = window.scrollY;
                            else window.scrollTo(0, $scope.yPos);

                            $scope.isExpanded = !$scope.isExpanded;

                            $scope.content.css({
                                'max-height': $scope.isExpanded ? '' : $scope.maxHeight + 'px',
                            });

                            if (!$scope.$$phase) {
                                $scope.$digest();
                            }
                        }

                        $timeout(function () {
                            $scope.overflow = $scope.content[0].offsetHeight > parseInt($scope.maxHeight) + 100;

                            if ($scope.overflow) {
                                $scope.content.css({
                                    'max-height': $scope.maxHeight + 'px',
                                    overflow: 'hidden',
                                });
                                $scope.button.bind('click', expand);
                            }
                        });
                    },
                ],
            };
        },
    ])
    .directive('dockElement', [
        '$window',
        function ($window) {
            return {
                link: function ($scope, element, attributes) {
                    var windowsYScroll =
                        window.scrollTop || window.scrollY || window.document.documentElement.scrollTop;
                    var elementTopPosition = getBoundingRectangle(element[0]).top + windowsYScroll;
                    var elementWidth = getBoundingRectangle(element[0]).width;
                    var locked = false;
                    var dockRelatedElementExists = !!attributes.dockElementAnchor;
                    var dockRelatedElementPadding = attributes.dockElementAnchorPadding
                        ? parseInt(attributes.dockElementAnchorPadding)
                        : 0;
                    var workingElement = dockRelatedElementExists
                        ? document.querySelector(attributes.dockElementAnchor)
                        : element[0];

                    if (attributes.hasOwnProperty('fixedHeader')) {
                        attributes.dockElement =
                            parseInt(attributes.dockElement) +
                            document.querySelector('.head').getBoundingClientRect().height;
                    }

                    function getBoundingRectangle(element) {
                        return element.getBoundingClientRect();
                    }

                    function getBoundingTopOffset(element) {
                        return getBoundingRectangle(element).top;
                    }

                    var latestDecision;

                    function updateView() {
                        var rectangle = getBoundingRectangle(workingElement);
                        windowsYScroll =
                            window.scrollTop || window.scrollY || window.document.documentElement.scrollTop;

                        var currentElementTopPosition = dockRelatedElementExists
                            ? rectangle.height + rectangle.top + windowsYScroll + dockRelatedElementPadding
                            : rectangle.top + windowsYScroll;

                        if (currentElementTopPosition > elementTopPosition) {
                            elementTopPosition = currentElementTopPosition;
                        }

                        var scrollTop = window.scrollTop || window.scrollY || window.document.documentElement.scrollTop;
                        var currentDecision =
                            parseInt(elementTopPosition - scrollTop) <= parseInt(attributes.dockElement || 0);

                        if (latestDecision !== currentDecision) {
                            latestDecision = currentDecision;

                            if (currentDecision) {
                                // dock
                                if (elementWidth < 50) {
                                    elementWidth = getBoundingRectangle(workingElement).width;
                                }

                                angular.element(element).css({
                                    position: 'fixed',
                                    top: attributes.dockElement + 'px',
                                    width: elementWidth + 'px',
                                    height: 'calc(100% - 200px)',
                                });
                            } else {
                                angular.element(element).css({
                                    position: 'relative',
                                    top: 'auto',
                                    width: 'auto',
                                    height: '475px',
                                });
                            }
                        }
                    }

                    angular.element(window).bind('scroll', function () {
                        updateView();
                    });
                },
            };
        },
    ])
    .directive('dockUpdates', [
        '$window',
        function ($window) {
            return {
                link: function ($scope, element, attributes) {
                    setTimeout(function () {
                        var windowsYScroll = $window.scrollY;
                        var initialTop = element[0].offsetTop;
                        var elementTopPosition = initialTop + windowsYScroll;
                        var elementWidth = getBoundingRectangle(element[0]).width;
                        var offsetTop = 12 + document.querySelector('.head').getBoundingClientRect().height;

                        function getBoundingRectangle(element) {
                            return element.getBoundingClientRect();
                        }

                        function getBoundingTopOffset(element) {
                            return getBoundingRectangle(element).top;
                        }

                        angular.element($window).bind('scroll', function () {
                            var height = elementTopPosition - $window.scrollY;

                            if (height <= offsetTop) {
                                // dock
                                angular.element(element).css({ top: offsetTop + 'px' });
                            } else {
                                angular.element(element).css({ top: height + 'px' });
                            }
                        });
                    });
                },
            };
        },
    ])
    .directive('protocolRequest', [
        '$window',
        function ($window) {
            return {
                link: function ($scope, element, attributes) {
                    angular.element(element).bind('click', function (event) {
                        protocolCheck('ty-agenatrader-v1://' + attributes.protocolRequest, function () {
                            protocolCheck('ty-client-v1://' + attributes.protocolRequest, function () {
                                window.location = attributes.alternativeRequest;
                            });
                        });

                        if (event.preventDefault) {
                            event.preventDefault();
                        } else {
                            event.returnValue = false;
                        }
                    });
                },
            };
        },
    ])
    .factory('contenteditableRegistry', [
        function () {
            var collection = {};

            return {
                new: function (id, element, range) {
                    collection[id] = { element: element, range: range };
                },
                has: function (id) {
                    return collection.hasOwnProperty(id);
                },
                get: function (id) {
                    return collection[id];
                },
                focus: function (id) {
                    var item = collection[id];
                    var itemRange = item.range;

                    function placeCaretAtEnd(el) {
                        el.focus();
                        if (typeof window.getSelection != 'undefined' && typeof document.createRange != 'undefined') {
                            var range = document.createRange();
                            range.selectNodeContents(el);
                            range.collapse(false);
                            itemRange = range;
                            var sel = window.getSelection();
                            sel.removeAllRanges();
                            sel.addRange(range);
                        } else if (typeof document.body.createTextRange != 'undefined') {
                            var textRange = document.body.createTextRange();
                            textRange.moveToElementText(el);
                            textRange.collapse(false);
                            textRange.select();
                        }
                    }

                    var range = document.createRange();
                    range.selectNode(item.element[0]);
                    range.collapse(false);

                    if (!itemRange) {
                        placeCaretAtEnd(item.element[0]);
                    }

                    range = itemRange;

                    var selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                },
                element: {
                    set: function (id, element) {
                        collection[id].element = element;
                    },
                    get: function (id) {
                        return collection[id].element;
                    },
                },
                range: {
                    get: function (id) {
                        return collection[id].range;
                    },
                    set: function (id, range) {
                        collection[id].range = range;
                    },
                },
            };
        },
    ])
    .directive('texteditable', [
        '$window',
        '$parse',
        'contenteditableRegistry',
        function ($window, $parse, contenteditableRegistry) {
            return {
                require: 'ngModel',
                link: function (scope, element, attributes, ngModel) {
                    element.html('');

                    if (
                        !contenteditableRegistry.has(attributes.texteditableId) &&
                        attributes.hasOwnProperty('texteditableId')
                    ) {
                        contenteditableRegistry.new(attributes.texteditableId, element);
                    }

                    // element.bind('hover', function() {
                    // carret position
                    // });

                    // element.keydown(function(event) {
                    //   if (event.keyCode === 13) {
                    //     document.execCommand('insertHTML', true, '<br><br>');
                    //     return false;
                    //   }
                    // });

                    function convertTextToHtml(content) {
                        // content = content.trim();
                        // value = content.replace(/\n+\s+\n+/g, '\n\n');
                        // value = content.replace(/\n\n+/g, '\n\n');
                        content = content.replace(/\n/g, '<br>');
                        // content = content.replace(/\s+/g, ' ');
                        return content;
                    }

                    function convertHtmlToText(value) {
                        // Convert `&amp;` to `&`.
                        value = value.replace(/&amp;/gi, '&');

                        // Replace spaces.
                        value = value.replace(/&nbsp;/gi, ' ');
                        // value = value.replace(/\s+/g, ' ');

                        // Remove "<b>".
                        value = value.replace(/<b>/gi, '');
                        value = value.replace(/<\/b>/gi, '');

                        // Remove "<strong>".
                        value = value.replace(/<strong>/gi, '');
                        value = value.replace(/<\/strong>/gi, '');

                        // Remove "<i>".
                        value = value.replace(/<i>/gi, '');
                        value = value.replace(/<\/i>/gi, '');

                        // Remove "<em>".
                        value = value.replace(/<em>/gi, '');
                        value = value.replace(/<\/em>/gi, '');

                        // Remove "<u>".
                        value = value.replace(/<u>/gi, '');
                        value = value.replace(/<\/u>/gi, '');

                        // Tighten up "<" and ">".
                        // value = value.replace(/>\s+/g, '>');
                        // value = value.replace(/\s+</g, '<');

                        // Replace "<br>".
                        value = value.replace(/<br>/gi, '\n');

                        value = value.replace(/<div>\s+<\/div>/gi, '');

                        // Replace "<div>" (from Chrome).
                        value = value.replace(/<div>/gi, '\n');
                        value = value.replace(/<\/div>/gi, '');

                        value = value.replace(/<p>\s+<\/p>/gi, '');

                        // Replace "<p>" (from IE).
                        value = value.replace(/<p>/gi, '\n');
                        value = value.replace(/<\/p>/gi, '');

                        // No more than 2x newline, per "paragraph".
                        // value = value.replace(/\n\n+/g, '\n\n');

                        // Whitespace before/after.
                        // value = value.trim();

                        return value;
                    }

                    //element.bind("paste", function(e) {
                    //    var clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData;
                    //    if (clipboardData) {
                    //      e.preventDefault();
                    //      var anyContent = clipboardData.getData("text/plain");
                    //      var newElement = document.createElement("p");
                    //      newElement.innerHTML = anyContent;
                    //      document.execCommand("insertHTML", false, convertTextToHtml(newElement.textContent));
                    //    }
                    //});

                    element.bind('mouseup keyup change select', function () {
                        if (window.getSelection && window.getSelection() && window.getSelection().rangeCount > 0) {
                            if (contenteditableRegistry.has(attributes.texteditableId)) {
                                var clonedRange = window.getSelection().getRangeAt(0).cloneRange();

                                contenteditableRegistry.range.set(attributes.texteditableId, clonedRange);
                            }
                        }
                    });

                    element.bind('dragover drop', function (event) {
                        event.preventDefault();
                        return false;
                    });

                    var modelValue = '';

                    function read() {
                        // var tmp = document.createElement("DIV");
                        // tmp.innerHTML = convertHtmlToText(element.html());
                        // ngModel.$setViewValue(tmp.textContent || tmp.innerText || "");
                    }

                    // ngModel.$render = function() {
                    //   // element.html(ngModel.$viewValue ? convertTextToHtml(ngModel.$viewValue) : "");
                    // };

                    // element.bind("blur keyup change", function() {
                    //   setTimeout(function() { scope.$apply(read); });
                    // });
                },
            };
        },
    ])
    .directive('onClickOut', [
        function () {
            return {
                link: function (scope, element, attributes) {
                    window.addEventListener(attributes.onClickTrigger || 'mousedown', function (event) {
                        function scopeDigest() {
                            if (!scope.$$phase) scope.$digest();
                        }

                        if (!attributes.onClickIf || scope.$eval(attributes.onClickIf)) {
                            if (!event.path) {
                                var pathes = [],
                                    cursor = event.target;

                                while (cursor) {
                                    pathes.push(cursor);
                                    cursor = cursor.parentNode;

                                    if (!cursor) {
                                        if (pathes.indexOf(element[0]) === -1) {
                                            scope.$eval(attributes.onClickOut);
                                            scopeDigest();
                                        }
                                    }
                                }
                            } else {
                                if (event.path.indexOf(element[0]) === -1) {
                                    scope.$eval(attributes.onClickOut);
                                    scopeDigest();
                                }
                            }
                        }
                    });
                },
            };
        },
    ])
    .directive('openAuthenticationDialog', [
        '$rootScope',
        '$parse',
        function ($rootScope, $parse) {
            return {
                restrict: 'A',
                link: function ($scope, element, $attr) {
                    var condition = $parse($attr.openAuthenticationDialogCondition)($scope);

                    element.bind('click', function ($event) {
                        bindButtonEvent($event, condition);
                    });

                    function bindButtonEvent($event, condition) {
                        if ((typeof condition !== 'undefined' && condition) || !$rootScope.me) {
                            if (typeof $event !== 'undefined' && $event.target.nodeName === 'A') {
                                $event.preventDefault();
                            }

                            $rootScope.$broadcast('open:authentication:dialog', 'signIn');
                        }
                    }
                },
            };
        },
    ])
    .directive('openRegistrationDialog', [
        '$rootScope',
        function ($rootScope) {
            return {
                link: function (scope, element, attr) {
                    element.bind('click', function ($event) {
                        if (typeof $event !== 'undefined') {
                            $event.stopPropagation();
                            $event.preventDefault();
                        }

                        $rootScope.$broadcast('open:authentication:dialog', 'signUp');
                    });
                },
            };
        },
    ])
    .directive('openGuestRegistrationDialog', [
        '$rootScope',
        function ($rootScope) {
            return {
                link: function (scope, element, attr) {
                    element.bind('click', function ($event) {
                        if (typeof $event !== 'undefined') {
                            $event.stopPropagation();
                            $event.preventDefault();
                        }

                        $rootScope.$broadcast('open:authentication:dialog', 'signUp', true);
                    });
                },
            };
        },
    ])
    .directive('actionConfirmation', [
        '$rootScope',
        '$parse',
        function ($rootScope, $parse) {
            return {
                link: function (scope, element, attributes) {
                    element.on('click', function () {
                        $rootScope.$broadcast('touchActionConfirmation', {
                            onConfirm: () => $parse(attributes.actionConfirmation)(scope),
                            questionContent: attributes.actionConfirmationQuestion,
                        });
                    });
                },
            };
        },
    ])
    .controller('actionConfirmationController', [
        '$scope',
        function ($scope) {
            var bodyElement = angular.element(document.querySelector('body'));
            var htmlElement = angular.element(document.querySelector('html'));
            $scope.isOpened = false;

            function scopeDigest() {
                if (!$scope.$$phase) {
                    $scope.$digest();
                }
            }

            $scope.$on('touchActionConfirmation', function (eventName, eventData) {
                $scope.onConfirm = eventData.onConfirm;
                $scope.questionContent = eventData.questionContent;

                $scope.isOpened = true;
                htmlElement.addClass('lock-scroll');
                // bodyElement.addClass('no-scroll');
                scopeDigest();
            });

            $scope.close = function () {
                $scope.onConfirm = undefined;
                $scope.questionContent = undefined;
                $scope.isOpened = false;
                htmlElement.removeClass('lock-scroll');
                scopeDigest();
            };

            $scope.confirm = function () {
                var possibleDefer = $scope.onConfirm();

                if (possibleDefer && possibleDefer.then) {
                    possibleDefer.then(function () {
                        $scope.close();
                    });
                } else {
                    $scope.close();
                }
            };

            $scope.cancel = function () {
                $scope.close();
            };
        },
    ])
    .factory('includeEntryMeetingService', [
        function () {
            var entryName, entryId;

            return {
                setEntry: function (_entryName, _entryId) {
                    entryName = _entryName;
                    entryId = _entryId;
                },
                getEntry: function () {
                    return {
                        entryName: entryName,
                        entryId: entryId,
                    };
                },
            };
        },
    ])
    .directive('includeEntryMeeting', [
        '$rootScope',
        '$parse',
        'includeEntryMeetingService',
        function ($rootScope, $parse, includeEntryMeetingService) {
            return {
                restrict: 'AE',
                priority: 100,
                compile: function () {
                    return {
                        pre: function ($scope, element, attributes) {
                            $scope.element = element;

                            var entryName = $parse(attributes.includeEntryMeeting)($scope);
                            var entryId = $parse(attributes.includeEntryMeetingId)($scope);

                            includeEntryMeetingService.setEntry(entryName, entryId);
                        },
                    };
                },
            };
        },
    ]);
